// extracted by mini-css-extract-plugin
export default {"lmsContainer":"Lms_lmsContainer__79fjS","buttonContainer":"Lms_buttonContainer__DdDPL"};